import axios from "axios";
import { IBatchCreateDto, IBatchUpdateDto } from "../types/batch.type";
import { IBlog, IBlogCreateDto } from "../types/blogs.type";
import { IBrand, IBrandCreateDto } from "../types/brands.type";
import { ICategory, ICategoryCreateDto, ICategoryOrderUpdateDto } from "../types/category.type";
import { IClient, IClientCreateDto } from "../types/clients.type";
import { IDiscount, IDiscountCreateDto } from "../types/discount.type";
import { IHistory } from "../types/history.type";
import {
  IOrder,
  IOrderPhoneCreateDto,
  IOrderShipped,
  IOrderUpdateDto,
  IProccessingCreateDto,
  IProccessingResponse,
  IWriteOffProductsOrder,
} from "../types/order.type";
import {
  IPhoneOrder,
  IPhoneOrderCreateDto,
  IPhoneOrderUpdateDto,
} from "../types/phoneOrder.type";
import {
  IProduct,
  IProductCreateDto,
  IProductsOrderUpdDto,
} from "../types/product.type";
import { IProductType, IProductTypeCreateDto } from "../types/productType.type";
import { IResource, IResourceCreateDto } from "../types/resources.type";
import { ISupplier, ISupplierCreateDto } from "../types/suppliers.type";
import { ITags, ITagsCreateDto } from "../types/tags.type";
import { IWarehouse, IWarehouseCreateDto } from "../types/warehouse.type";
import { BASE_URL } from "../utils/constants/api";
import {
  IEmployee,
  IEmployeeCreateDto,
  IEmployeeUpdateDto,
  ILoginResponse,
  IUser,
  IUserChangeDto,
  IUserCreateDto,
  IUserCreateResponse,
} from "./api.interface";

export const unAuthApiService = {
  login: async (email: string, password: string): Promise<ILoginResponse> => {
    const response = await axios.post(`${BASE_URL}/auth/login`, {
      email,
      password,
    });
    return response.data;
  },
  confirmAuthentication: async (code: string): Promise<any> => {
    const response = await axios.post(
      `${BASE_URL}/auth/confirm-authorization-code`,
      { code }
    );
    return response.data;
  },
  confirmEmail: async (code: string, email: string): Promise<any> => {
    const response = await axios.post(`${BASE_URL}/auth/confirm-email`, {
      code,
      email,
    });
    return response.data;
  },
  sendNewCode: async (email: string): Promise<any> => {
    const response = await axios.post(`${BASE_URL}/auth/send-new-code`, {
      email,
    });
    return response.data;
  },
  endRegistrations: async (email: string) => {
    const response = await axios.post(`${BASE_URL}/email/end-registration`, {
      email,
    });
    return response.data;
  },
  changePassword: async (
    email: string,
    newPassword: string,
    confirmPassword: string,
    code: string
  ): Promise<any> => {
    const response = await axios.post(`${BASE_URL}/auth/change-password`, {
      email,
      newPassword,
      confirmPassword,
      code,
    });
    return response.data;
  },
  createNewPassword: async (
    newPassword: string,
    confirmPassword: string,
    code: string
  ): Promise<any> => {
    const response = await axios.post(`${BASE_URL}/auth/create-password`, {
      code,
      newPassword,
      confirmPassword,
    });
    return response.data;
  },
};

export const authApiService = {
  getMe: async (): Promise<IUser | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token || token === "undefined") {
      return;
    }

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(`${BASE_URL}/users/me`, config);
    return response.data;
  },

  getAllUsers: async (): Promise<IUser[] | undefined> => {
    const token = localStorage.getItem("accessToken");
    console.log("token", token);

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(
      `${BASE_URL}/users/all?orderBy=createdAt&orderType=ASC&per_page=100`,
      config
    );

    console.log(response);

    return response.data;
  },

  setUser: async (id: string, user: IUserChangeDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.put(
      `${BASE_URL}/users/update/${id}`,
      user,
      config
    );

    return response.data;
  },

  deleteUser: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.delete(`${BASE_URL}/users/${id}`, config);
    return response.data;
  },

  createUser: async (
    user: IUserCreateDto
  ): Promise<IUserCreateResponse | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/auth/register/`,
      user,
      config
    );

    return response.data;
  },

  getAllEmployee: async (): Promise<IEmployee[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/employee/all?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );

    return response.data;
  },

  createEmployee: async (employee: IEmployeeCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/employee/create`,
      employee,
      config
    );

    return response.data;
  },

  updateEmployee: async (employee: IEmployeeUpdateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/employee/update/${employee.id}`,
      employee,
      config
    );

    return response.data;
  },

  deleteEmployee: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/employee/delete/${id}`,
      config
    );

    return response.data;
  },

  uploadImage: async (formData: FormData) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    console.log(formData);

    const response = await axios.post(
      `${BASE_URL}/files-cdn/upload`,
      formData,
      config
    );

    return response.data;
  },

  getAllResources: async (): Promise<IResource[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/resources/all?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );

    return response.data;
  },
  createResource: async (
    resourse: IResourceCreateDto
  ): Promise<any | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/resources/create`,
      resourse,
      config
    );

    return response.data;
  },
  deleteResource: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/resources/delete/${id}`,
      config
    );

    return response.data;
  },

  updateResource: async (id: string, resource: IResourceCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/resources/update/${id}`,
      resource,
      config
    );

    return response.data;
  },

  getAllSuppliers: async (): Promise<ISupplier[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/providers/all?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );

    return response.data;
  },

  createSupplier: async (body: ISupplierCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/providers/create`,
      body,
      config
    );

    return response.data;
  },

  updateSupplier: async (id: string, body: ISupplierCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/providers/update/${id}`,
      body,
      config
    );

    return response.data;
  },

  deleteSupplier: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/providers/delete/${id}`,
      config
    );

    return response.data;
  },

  getAllWarehouse: async (): Promise<IWarehouse[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/resources/all-with-relations?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );
    return response.data;
  },

  createWarehouse: async (body: IWarehouseCreateDto[]) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/warehouses/create/resource-warehouse`,
      body,
      config
    );

    return response.data;
  },

  updateWarehouse: async (id: string, body: IWarehouseCreateDto[]) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/warehouses/update/resource-warehouse/${id}`,
      body,
      config
    );

    return response.data;
  },

  deleteWarehouse: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/warehouses/delete/resource-warehouse/${id}`,
      config
    );

    return response.data;
  },

  getAllClients: async (): Promise<IClient[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/clients/all?orderBy=createdAt&orderType=ASC&per_page=10000`,
      config
    );

    return response.data;
  },
  createClient: async (body: IClientCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/clients/create`,
      body,
      config
    );

    return response.data;
  },
  updateClient: async (id: string, body: IClientCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/clients/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteClient: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/clients/delete/${id}`,
      config
    );

    return response.data;
  },

  getAllTags: async (): Promise<ITags[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/products/tags?per_page=10000`,
      config
    );

    return response.data;
  },
  createTag: async (body: ITagsCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/products/create-tag`,
      body,
      config
    );

    return response.data;
  },
  updateTag: async (id: string, body: ITagsCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/products/update-tag/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteTag: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/products/delete-tag/${id}`,
      config
    );

    return response.data;
  },
  getAllProductTypes: async (): Promise<IProductType[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/products/product-types?per_page=10000`,
      config
    );

    return response.data;
  },
  createProductType: async (body: IProductTypeCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/products/create-product-type`,
      body,
      config
    );

    return response.data;
  },
  updateProductType: async (id: string, body: IProductTypeCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/products/update-product-type/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteProductType: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/products/delete-product-type/${id}`,
      config
    );

    return response.data;
  },
  getAllCategories: async (): Promise<ICategory[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/products/categories?per_page=10000`,
      config
    );

    return response.data;
  },
  createCategory: async (body: ICategoryCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/products/create-category`,
      body,
      config
    );

    return response.data;
  },
  updateCategory: async (id: string, body: ICategoryCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/products/update-category/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteCategory: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/products/delete-category/${id}`,
      config
    );

    return response.data;
  },
  updateCategoriesOrder: async (
    body: ICategoryOrderUpdateDto[]
  ): Promise<ICategory[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/products/update-categories-order`,
      body,
      config
    );

    return response.data;
  },
  getAllBrands: async (): Promise<IBrand[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/products/brands?per_page=10000`,
      config
    );

    return response.data;
  },
  createBrand: async (body: IBrandCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/products/create-brand`,
      body,
      config
    );

    return response.data;
  },
  updateBrand: async (id: string, body: IBrandCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/products/update-brand/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteBrand: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/products/delete-brand/${id}`,
      config
    );

    return response.data;
  },

  getAllDiscounts: async (): Promise<IDiscount[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/products/discounts?per_page=10000`,
      config
    );

    return response.data;
  },
  createDiscount: async (body: IDiscountCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/products/create-discount`,
      body,
      config
    );

    return response.data;
  },
  updateDiscount: async (id: string, body: IDiscountCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/products/update-discount/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteDiscount: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/products/delete-discount/${id}`,
      config
    );

    return response.data;
  },
  getAllProducts: async (): Promise<IProduct[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/products/all?per_page=10000`,
      config
    );

    return response.data.data;
  },
  getAllProductsForOrder: async (): Promise<IProduct[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/products/all?per_page=10000`,
      config
    );

    return response.data.data;
  },
  createProduct: async (body: IProductCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/products/create`,
      body,
      config
    );

    return response.data;
  },
  updateProduct: async (id: string, body: IProductCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/products/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteProduct: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/products/one/${id}`,
      config
    );

    return response.data;
  },
  createBatch: async (body: IBatchCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/products/create-batch`,
      body,
      config
    );

    return response.data;
  },
  updateBatch: async (id: string, body: IBatchUpdateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/products/update-batch/${id}`,
      body,
      config
    );

    return response.data;
  },
  deleteBatch: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.delete(`${BASE_URL}/batches/${id}`, config);
    return response.data;
  },
  getAllOrders: async (): Promise<IOrder[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/orders/all?orderBy=createdAt&orderType=DESC&per_page=10000`,
      config
    );

    return response.data.data;
  },
  createProccessing: async (
    body: IProccessingCreateDto
  ): Promise<IProccessingResponse | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/processing-order/create`,
      body,
      config
    );

    return response.data;
  },
  writeOffOrder: async (body: IWriteOffProductsOrder) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/processing-order/write-off`,
      body,
      config
    );

    return response.data;
  },
  updateOrderStatus: async (id: string, body: IOrderUpdateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/orders/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  shippedOrder: async (id: string, body: IOrderShipped) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/orders/shipped/${id}`,
      body,
      config
    );

    return response.data;
  },

  getHistory: async (): Promise<IHistory[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/history/all?per_page=10000`,
      config
    );

    return response.data.data;
  },
  createOrderPhone: async (body: IOrderPhoneCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/phone-orders/create`,
      body,
      config
    );

    return response.data;
  },
  getAllPhoneOrders: async (): Promise<IPhoneOrder[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/phone-orders/all?per_page=10000`,
      config
    );

    return response.data.data;
  },
  createPhoneOrder: async (body: IPhoneOrderCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/phone-orders/create`,
      body,
      config
    );

    return response.data;
  },
  updatePhoneOrder: async (id: number, body: IPhoneOrderUpdateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/phone-orders/update/${id}`,
      body,
      config
    );

    return response.data;
  },
  /** @deprecated Використовуйте updatePhoneOrder */
  updatePhoneOrderStatus: async (id: number, body: IPhoneOrderUpdateDto) => {
    return authApiService.updatePhoneOrder(id, body);
  },
  createPhoneOrderProccessing: async (
    body: IProccessingCreateDto
  ): Promise<IProccessingResponse | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/processing-order/create-for-phone-order`,
      body,
      config
    );

    return response.data;
  },
  writeOffPhoneOrder: async (body: IWriteOffProductsOrder) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/processing-order/write-off-to-processing-phone-order`,
      body,
      config
    );

    return response.data;
  },
  shippedPhoneOrder: async (id: number, body: IOrderShipped) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/phone-orders/shipped/${id}`,
      body,
      config
    );

    return response.data;
  },
  copyProduct: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.patch(
      `${BASE_URL}/products/${id}/copy`,
      {},
      config
    );

    return response.data;
  },
  updateProductsOrder: async (body: IProductsOrderUpdDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/products/update-orders`,
      body,
      config
    );

    return response.data;
  },
  getAllNewPaidOrders: async (): Promise<IOrder[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/orders/paid?per_page=10000`,
      config
    );

    return response.data.data;
  },
  getAllExpiringProducts: async (): Promise<IProduct[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      `${BASE_URL}/products/all/expiring?per_page=10000`,
      config
    );

    return response.data.data;
  },

  getAllBlogs: async (): Promise<IBlog[] | undefined> => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(`${BASE_URL}/blogs/all`, config);

    return response.data;
  },

  createBlog: async (body: IBlogCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(`${BASE_URL}/blogs/create`, body, config);

    return response.data;
  },

  updateBlog: async (id: string, body: IBlogCreateDto) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(
      `${BASE_URL}/blogs/update/${id}`,
      body,
      config
    );

    return response.data;
  },

  deleteBlog: async (id: string) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(
      `${BASE_URL}/blogs/delete/${id}`,
      config
    );

    return response.data;
  },
};
